import type { RegisteredComponent } from "@builder.io/sdk-react";

import { IconPickerBase, type IconPickerProps } from "./base";
import { iconMap } from "./icon-map";
import { iconPickerInputs } from "./inputs";

const IconPicker = (props: IconPickerProps) => (
  <IconPickerBase icons={iconMap} {...props} />
);

export const IconDefinition = {
  component: IconPicker,
  name: "IconPicker",
  noWrap: true,
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/smile.svg",
  inputs: iconPickerInputs,
} satisfies RegisteredComponent;

export default IconPicker;
